import React, { type FunctionComponent, type ReactNode } from 'react'
import { Button } from '@tomra/design-system-react/button'

type Props = {
  isOpen: boolean
  onClose: () => void
  children?: ReactNode
}

export const MapDialog: FunctionComponent<Props> = ({ isOpen, onClose, children }) => {
  return (
    <div
      className={`rounded-2xl bg-white shadow-md dark:bg-gray-900 mx-6 absolute p-6 w-[calc(100%-3rem)] transition z-[2] ${
        isOpen ? '-translate-y-[98%]' : '-translate-y-[100%]}'
      }`}
    >
      <Button
        variant="icon"
        className="absolute top-4 right-4 rounded-sm z-10 bg-white"
        onClick={onClose}
        aria-label="Close"
      >
        <span className="icon-[fluent--dismiss-24-regular] size-6" />
      </Button>
      {children}
    </div>
  )
}
